import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";
import {
  DialogContent,
  DialogContentText,
  Grid,
  Tab,
  Tabs,
} from "@mui/material";
import Popup from "../../../components/common/model/Popup";
import FormField from "../../../components/common/FormField";
import { surveryAllFields, surveryEventAllFields } from "./diaryAllFields";
import { useDispatch } from "react-redux";
import Validation from "../../../utils/Validation";
import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import {
  addSurveyDiaryAction,
  addSurveyEventAction,
  deleteSurveyEventAction,
  getLeadToSurveyAction,
  getSingleSurveyAction,
  getSingleSurveyEventAction,
  getSurvoyerListAction,
  initialSurveyEventLocalState,
  resetNewSurveyAction,
  resetNewSurveyEventAction,
  setAddSurveyDiaryResponse,
  setNewSurveyAction,
  setNewSurveyEventAction,
  setSingleSurveyAction,
  setUpdateSurveyDiaryResponse,
  updateNewSurveyAction,
  updateSurveyDiaryAction,
  updateSurveyEventAction,
} from "../../../store/reducers/surveyDiarySlice";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import ResetFormAlert from "./ResetFormAlert";
import CustomButton from "../../../components/common/button/CustomButton";

interface surveyDetail {
  surveyorId: string | null;
  surveyType: string | null;
  remarks: string | null;
  surveyDate: string | null;
  startTime: string | null;
  endTime: string | null;
  description: string | null;
  [key: string]: string | null; // Add index signature
}

interface ManageNewSurveyAppointmentProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedSurvey?: any; // Adjust type as per your requirement
  selectedDate?: any;
  surveyorType?: any;
  tabValue?: any;
  selectedResource?: any;
  action?: any;
}

const ManageNewSurveyAppointment: React.FC<ManageNewSurveyAppointmentProps> = (
  props,
) => {
  const {
    selectedSurvey,
    onHide,
    open,
    title,
    selectedDate,
    surveyorType,
    tabValue,
    selectedResource,
    action,
  } = props;

  const initialSurveyDetail = {
    surveyorId: "",
    leadId: "",
    surveyType: "",
    remarks: "",
    surveyDate: "",
    startTime: "",
    endTime: "",
    description: "",
  };
  // surveyDetail is a state variable to store the survey details
  const [surveyDetail, setSurveyDetail] =
    useState<surveyDetail>(initialSurveyDetail);
  // surveyEventDetail is a state variable to store the survey event details
  const [surveyEventDetail, setSurveyEventDetail] = useState<any>(
    initialSurveyEventLocalState,
  );

  const dispatch = useDispatch();

  const {
    customerSurveyList,
    surveyorList,
    newSurveyLocal,
    isSurveyDiarySuccess,
    isSurveyDiaryUpdateSuccess,
    isSurveyEventSuccess,
    surveyDiaryDetail,
    newEventLocal,
    surveyDiaryEventDetail,
  } = useSelector((state: any) => state?.surveyDiary);

  console.log("called surveyDiaryDetail", surveyDiaryDetail);
  const [leadDetails, setLeadDetails] = useState<any>(null);
  useEffect(() => {
    const stored = sessionStorage.getItem("leadDetails");
    setLeadDetails(stored ? JSON.parse(stored) : null);
  }, [open]);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    surveyorId: newSurveyLocal?.survey?.surveyorId,
    surveyType: newSurveyLocal?.survey?.surveyType,
    startTime: newSurveyLocal?.survey?.startTime,
    // endTime: newSurveyLocal?.survey?.endTime,
    customer_name: newSurveyLocal?.survey?.customer_name,
  });

  const [
    eventErrors,
    checkEventValidator,
    resetEventValidator,
    resetAllEventValidator,
    isEventError,
  ]: any = Validation({
    eventType: newEventLocal?.eventType,
    startDate: newEventLocal?.startDate,
    endDate: newEventLocal?.endDate,
  });

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm"); // Adjust the type definition
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [isEventActionCalled, setIsEventActionCalled] = useState(false);
  const [disabledForm, setDisabledForm] = useState(false);
  const [value, setValue] = useState(tabValue);
  const classes = useStyles();

  // check user role
  const [userProfile, setUserProfile] = useState<any>(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUserProfile(JSON.parse(storedUser));
    }
  }, []);

  const buildLeadDescription = (lead: any) => {
    if (!lead) return "";

    const addresses = lead.collection_address || [];

    const formattedAddresses = addresses
      .map((addr: any, index: number) => {
        const street = addr?.street || "";
        const town = addr?.town || "";
        const country = addr?.country || "";
        const postcode = addr?.postcode || "";

        return `\nAddress ${
          index + 1
        } : ${street}, ${town}, ${country}, ${postcode}`;
      })
      .join("\n");

    return `Client Email : ${lead.customer_email}\nMobile :  ${
      lead.customer_country_code && lead.customer_phone
        ? `${lead.customer_country_code}${lead.customer_phone}`
        : lead.customer_phone
          ? lead.customer_phone
          : ""
    }${formattedAddresses}`;
  };


  useEffect(() => {
    if (surveyDiaryDetail || isClickReset) {
      const description =
        surveyDiaryDetail?.description?.trim() ||
        buildLeadDescription(leadDetails?.lead);

      dispatch(
        setNewSurveyAction({
          survey: {
            ...surveyDiaryDetail,
            surveyorId: surveyDiaryDetail?.surveyor_id,
            surveyType: surveyDiaryDetail?.survey_type,
            leadId: surveyDiaryDetail?.leadId,
            surveyDate: dayjs(surveyDiaryDetail?.start_time).format(
              "YYYY-MM-DD",
            ),
            startTime: surveyDiaryDetail?.start_time,
            endTime: surveyDiaryDetail?.end_time,
            customer_name: surveyDiaryDetail?.customerName,
            description,
          },
        }),
      );
      setSurveyDetail((prevDetails) => ({
        ...prevDetails,
        surveyorId: surveyDiaryDetail?.surveyor_id,
        surveyType: surveyDiaryDetail?.survey_type,
        leadId: surveyDiaryDetail?.leadId,
        surveyDate: dayjs(surveyDiaryDetail?.start_time).format("YYYY-MM-DD"),
        startTime: surveyDiaryDetail?.start_time,
        endTime: surveyDiaryDetail?.end_time,
        description,
      }));
    }
  }, [surveyDiaryDetail, isClickReset, leadDetails]);

  useEffect(() => {
    if (!leadDetails?.lead) return; // ⛔ Exit early if leadDetails or lead is missing
    console.log("called if condition - surveyDiaryDetail", surveyDiaryDetail);
    if ((open || isClickReset) && !surveyDiaryDetail) {
      const description = buildLeadDescription(leadDetails.lead);

      setSurveyDetail((prevDetails) => ({
        ...prevDetails,
        customer_name: leadDetails.lead.customer_name,
        leadId: leadDetails.lead.generated_id,
        description,
        ...(surveyorType === "self" && {
          surveyorId: userProfile?.user?.staff_id,
        }),
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            customer_name: leadDetails.lead.customer_name,
            leadId: leadDetails.lead.generated_id,
            description,
            ...(surveyorType === "self" && {
              surveyorId: userProfile?.user?.staff_id,
            }),
          },
        }),
      );
    }
  }, [surveyDiaryDetail, leadDetails, open, isClickReset]);

  useEffect(() => {
    dispatch(getSurvoyerListAction());
    // dispatch(getLeadToSurveyAction());
  }, []);

  useEffect(() => {
    if (
      isSurveyDiarySuccess ||
      isSurveyDiaryUpdateSuccess ||
      isSurveyEventSuccess
    ) {
      hideHandler();
    }
  }, [isSurveyDiarySuccess, isSurveyDiaryUpdateSuccess, isSurveyEventSuccess]);

  useEffect(() => {
    if (selectedDate) {
      const startTime = dayjs(selectedDate);
      const endTime = startTime.add(60, "minute"); // Add 30 minutes to start time
      setSurveyDetail((prevDetails) => ({
        ...prevDetails,
        surveyDate: dayjs(selectedDate).format("YYYY-MM-DD"),
        startTime: startTime.toISOString(),
        endTime: endTime.toISOString(),
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            surveyDate: dayjs(selectedDate).format("YYYY-MM-DD"),
            startTime: startTime.toISOString(),
            endTime: endTime.toISOString(), // Set endTime 30 minutes after startTime
          },
        }),
      );

      // for events form
      setSurveyEventDetail((prevState: any) => ({
        ...prevState,
        startDate: selectedDate.toISOString(),
        endDate: endTime.toISOString(),
      }));

      dispatch(
        setNewSurveyEventAction({
          ...newEventLocal,
          startDate: selectedDate.toISOString(),
          endDate: endTime.toISOString(),
        }),
      );
    }
  }, [selectedDate]);

  // Combine selectedDate and selectedResource updates into a single effect
  useEffect(() => {
    if (selectedDate && selectedResource) {
      const startTime = dayjs(selectedDate);
      const endTime = startTime.add(60, "minute"); // Add 30 minutes

      const updatedEvent = {
        ...surveyEventDetail,
        startDate: startTime.toISOString(),
        endDate: endTime.toISOString(),
        surveyorId: selectedResource?.id,
        assignTo: selectedResource?.name,
      };

      setSurveyEventDetail(updatedEvent);
      dispatch(setNewSurveyEventAction(updatedEvent));
    }
  }, [selectedDate, selectedResource]);

  const handleEventInputChange = (field: string, value: any) => {
    setSurveyEventDetail((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));

    dispatch(
      setNewSurveyEventAction({
        ...newEventLocal,
        [field]: value,
      }),
    );
    resetEventValidator(field);
  };

  const handleInputChange = (field: string, value: any) => {
    // If the startTime is being updated, update the end_time dynamically
    if (field === "startTime" && value) {
      const newStartTime = dayjs(value);

      // Get the previous start and end times
      const prevStartTime = dayjs(newSurveyLocal?.survey?.startTime);
      const prevEndTime = dayjs(newSurveyLocal?.survey?.endTime);

      // Default to 1 hour if no previous end time
      const timeDiffInMinutes = prevEndTime.isValid()
        ? prevEndTime.diff(prevStartTime, "minute")
        : 60;

      const newEndTime = newStartTime
        .add(timeDiffInMinutes, "minute")
        .toISOString();

      // Update both startTime and end_time
      setSurveyDetail((prevState) => ({
        ...prevState,
        startTime: value,
        endTime: newEndTime,
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            startTime: value,
            endTime: newEndTime,
          },
        }),
      );
    } else {
      setSurveyDetail((prevState) => ({
        ...prevState,
        [field]: value,
      }));

      dispatch(
        setNewSurveyAction({
          survey: {
            ...newSurveyLocal?.survey,
            [field]: value,
          },
        }),
      );
    }

    resetValidator(field);
  };

  const hideHandler = () => {
    props.onHide();
    resetAllValidator();
    handleClear();
    dispatch(setSingleSurveyAction(""));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
        console.log("action-422",action);
      if (!isError() && error !== null && isActionCalled) {
        if (selectedSurvey) {
          dispatch(
            updateNewSurveyAction({
              ...surveyDetail,
              id: selectedSurvey,
              isCopyExisting: action === "isCopy" ? true : false,
              isCreateNew: action === "isCreate" ? true : false,
            }),
          );
        } else {
          dispatch(updateNewSurveyAction(surveyDetail));
        }
      } else {
        console.log("API Error", error);
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleSubmitEvent = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkEventValidator();
    setIsEventActionCalled(true);
  };

  useEffect(() => {
    if (isEventActionCalled) {
      if (!isEventError() && eventErrors !== null && isEventActionCalled) {
        if (selectedSurvey) {
          dispatch(
            updateSurveyEventAction({
              ...surveyEventDetail,
              id: selectedSurvey,
            }),
          );
        } else {
          dispatch(addSurveyEventAction(surveyEventDetail));
        }
      } else {
        console.log("API Error", error);
      }
      setIsEventActionCalled(false);
    }
  }, [isEventActionCalled]);

  const onBlurAction = (e: any) => {
    console.log("onBlurAction called for", e.target.id);
    checkValidator(e.target.id);
  };

  const onEventBlurAction = (e: any) => {
    checkEventValidator(e.target.id);
  };
  // Surveyor Form Elements
  const updateField = surveryAllFields.map((field) => {
    if (field.id === "surveyorId") {
      return {
        ...field,
        options: [
          { label: "Self", id: userProfile?.user?.staff_id }, // Adding the extra dropdown option
          ...surveyorList.map((item: any) => ({
            label: item?.name,
            id: item?.staff_id,
          })),
        ],
      };
    }

    return field;
  });

  useEffect(() => {
    if (selectedSurvey) {
      if (tabValue === "0") {
        dispatch(getSingleSurveyEventAction(selectedSurvey));
      } else {
        dispatch(getSingleSurveyAction(selectedSurvey));
      }
    }
  }, [selectedSurvey]);

  useEffect(() => {
    if (surveyDiaryEventDetail || isClickReset) {
      dispatch(
        setNewSurveyEventAction({
          ...surveyDiaryEventDetail,
          surveyorId: surveyDiaryEventDetail?.surveyor_id,
          assignTo: selectedResource?.name,
          eventType: surveyDiaryEventDetail?.event_type,
          event: surveyDiaryEventDetail?.event,
          startDate: surveyDiaryEventDetail?.start_date,
          endDate: surveyDiaryEventDetail?.end_date,
        }),
      );

      setSurveyEventDetail((prevDetails: any) => ({
        ...prevDetails,
        surveyorId: surveyDiaryEventDetail?.surveyor_id,
        assignTo: selectedResource?.name,
        eventType: surveyDiaryEventDetail?.event_type,
        event: surveyDiaryEventDetail?.event,
        startDate: surveyDiaryEventDetail?.start_date,
        endDate: surveyDiaryEventDetail?.end_date,
      }));
    }
  }, [surveyDiaryEventDetail, isClickReset]);

  useEffect(() => {
    if (isClickReset) {
      if (value === "0") {
        handleEventClear();
      } else {
        handleClear();
      }
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handleEventClear = () => {
    if (surveyEventDetail?.id) {
      setSurveyEventDetail(surveyEventDetail);
    } else {
      setSurveyEventDetail(initialSurveyEventLocalState);
    }
    dispatch(resetNewSurveyEventAction());
    resetAllEventValidator();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setIsClickReset(false);
    setAlertModelShow(false);
  };

  const handleClear = () => {
    if (surveyDiaryDetail?.id) {
      setSurveyDetail(surveyDiaryDetail);
    } else {
      setSurveyDetail(initialSurveyDetail);
    }

    dispatch(resetNewSurveyAction());
    dispatch(setAddSurveyDiaryResponse(false));
    dispatch(setUpdateSurveyDiaryResponse(false));
    resetAllValidator();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setIsClickReset(false);
    setAlertModelShow(false);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleRemoveEvent = () => {
    dispatch(deleteSurveyEventAction(selectedSurvey));
  };

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={value === "0" ? "Add Events" : title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        popupBg="#fff"
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            {!disabledForm && (
              <>
                <img
                  onClick={(e: any) =>
                    value === "0" ? handleSubmitEvent(e) : handleSubmit(e)
                  }
                  src={checkedIcon}
                  className={classes.checkicons}
                  alt="save"
                />
                <img
                  onClick={openClearPopup}
                  src={deleteIcon}
                  className={classes.deleteicons}
                  alt="delete"
                />
              </>
            )}
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            {selectedSurvey && value === "0" && (
              <CustomButton
                style={{ padding: "10px 30px", height: "36px" }}
                //  variant="outlined"
                title="Delete Event"
                onClick={handleRemoveEvent}
              />
            )}
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 4px 0px 4px !important" }}>
          <DialogContentText className={classes.formAddBox}>
            <>
              <Notification />
              {tabValue === "0" && (
                <Tabs
                  centered
                  value={value}
                  // disabled={tabValue === "1" ? true : false}
                  onChange={handleChange}
                  textColor="secondary"
                  indicatorColor="secondary"
                  aria-label="secondary tabs example"
                  variant="standard"
                  sx={{
                    background: "#e5f4f1",
                    fontSize: "14px",
                    fontWeight: 600,
                    marginBottom: "16px",
                    borderRadius: "5px",
                    border: "1px solid #CFCFCF",
                  }}
                >
                  <Tab value="0" label="Events" />
                  <Tab value="1" label="Appointments" />
                </Tabs>
              )}
              {value === "0" ? (
                <>
                  <Grid
                    container
                    spacing={0.5}
                    sx={{
                      background: "#e5f4f1",
                      padding: "16px",
                      borderRadius: "5px",
                      border: "1px solid #CFCFCF",
                    }}
                  >
                    {surveryEventAllFields.map((field, i) => {
                      return (
                        <FormField
                          key={field.id}
                          onPaste={(e) => e.preventDefault()}
                          onKeyDown={(event: any) => {
                            console.log(
                              "event log-",
                              event,
                              event.target.value + event.key,
                            );
                            if (
                              event.keyCode === 8 ||
                              event.keyCode === 9 ||
                              event.keyCode === 37 ||
                              event.keyCode === 38 ||
                              event.keyCode === 39 ||
                              event.keyCode === 40 ||
                              event.keyCode === 18 ||
                              event.keyCode === 17 ||
                              event.ctrlKey
                            )
                              return event;
                            if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(event.key)
                            ) {
                              event.preventDefault();
                            } else if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(
                                event.target.value + event.key,
                              )
                            ) {
                              event.preventDefault();
                            }
                          }}
                          {...{
                            ...field,
                            ...{
                              variant: "outlined", // Adding this variant prop
                              ...((field?.id === "surveyorId" ||
                                field?.id === "surveyType") && {
                                disabled:
                                  userProfile?.user?.roles?.includes(
                                    "TENANT",
                                  ) ||
                                  userProfile?.user?.roles?.includes("Admin") ||
                                  userProfile?.user?.roles?.includes("Owner")
                                    ? surveyorType === "self" &&
                                      field?.id === "surveyorId"
                                      ? true
                                      : false || disabledForm
                                    : true,
                              }),
                              ...((field?.id === "startDate" ||
                                field?.id === "endDate") && {
                                disabled: disabledForm,
                              }),
                              // disabled :(field?.id==='startTime' || field?.id==='endTime') && disabledForm,
                              InputProps: {
                                ...(field?.inputProps && field?.inputProps),
                                sx: { height: "36px" },
                                autocomplete: "user-new-field",
                              },
                              value: newEventLocal
                                ? newEventLocal[field.id]
                                : "",
                              inSingleGridForm: true,
                              isNonMarginTop: true,
                              minDate:
                                field.id === "endDate"
                                  ? newEventLocal?.startDate &&
                                    newEventLocal?.startDate
                                  : undefined,
                              minTime:
                                field.id === "endDate"
                                  ? newEventLocal?.startDate &&
                                    newEventLocal?.startDate
                                  : undefined,
                              onBlur: onEventBlurAction,
                              onChange: (e: any) =>
                                handleEventInputChange(
                                  field.id,
                                  e.target.value,
                                ), // Call onChange prop
                              error: eventErrors && eventErrors[field?.id],
                              helperText: eventErrors && eventErrors[field?.id],
                            },
                          }}
                        />
                      );
                    })}
                  </Grid>
                </>
              ) : (
                <>
                  <Grid
                    container
                    direction="row"
                    spacing={0.5}
                    sx={{
                      background: "#e5f4f1",
                      padding: "16px",
                      borderRadius: "5px",
                      border: "1px solid #CFCFCF",
                    }}
                  >
                    {updateField.map((field, i) => {
                      return (
                        <FormField
                          key={i}
                          onPaste={(e) => e.preventDefault()}
                          onKeyDown={(event: any) => {
                            console.log(
                              "event log-",
                              event,
                              event.target.value + event.key,
                            );
                            if (
                              event.keyCode === 8 ||
                              event.keyCode === 9 ||
                              event.keyCode === 37 ||
                              event.keyCode === 38 ||
                              event.keyCode === 39 ||
                              event.keyCode === 40 ||
                              event.keyCode === 18 ||
                              event.keyCode === 17 ||
                              event.ctrlKey
                            )
                              return event;
                            if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(event.key)
                            ) {
                              event.preventDefault();
                            } else if (
                              field?.patternAllowed &&
                              !field?.patternAllowed.test(
                                event.target.value + event.key,
                              )
                            ) {
                              event.preventDefault();
                            }
                          }}
                          {...{
                            ...field,
                            ...{
                              variant: "outlined", // Adding this variant prop
                              ...((field?.id === "surveyorId" ||
                                field?.id === "surveyType") && {
                                disabled:
                                  userProfile?.user?.roles?.includes(
                                    "TENANT",
                                  ) ||
                                  userProfile?.user?.roles?.includes("Admin") ||
                                  userProfile?.user?.roles?.includes("Owner")
                                    ? surveyorType === "self" &&
                                      field?.id === "surveyorId"
                                      ? true
                                      : false || disabledForm
                                    : true,
                              }),
                              ...((field?.id === "startTime" ||
                                field?.id === "endTime") && {
                                disabled: disabledForm,
                              }),
                              inSingleGridForm: true,
                              InputProps: {
                                ...(field?.inputProps && field?.inputProps),
                                sx: { height: "36px" },

                                ...((field?.id === "customer_name" ||
                                  field?.id === "description") && {
                                  disabled: field?.editReadOnly || disabledForm,
                                }),

                                autocomplete: "user-new-field",
                              },
                              isNonMarginTop: true,
                              GridFieldStyle: {
                                marginTop:
                                  field?.id === "customer_name"
                                    ? "6px !important"
                                    : field?.id === "description"
                                      ? "6px !important"
                                      : "0px !important",
                              },
                              value: newSurveyLocal?.survey
                                ? newSurveyLocal?.survey[field.id]
                                : "",
                              minDate:
                                field.id === "endTime" &&
                                newSurveyLocal?.survey?.endTime
                                  ? newSurveyLocal?.survey?.startTime &&
                                    newSurveyLocal?.survey?.startTime
                                  : undefined,
                              minTime:
                                field.id === "endTime" &&
                                newSurveyLocal?.survey?.endTime
                                  ? newSurveyLocal?.survey?.startTime &&
                                    newSurveyLocal?.survey?.startTime
                                  : undefined,
                              onBlur: onBlurAction,
                              onChange: (e: any) =>
                                handleInputChange(field.id, e.target.value), // Call onChange prop
                              error: !disabledForm
                                ? field.id === "endTime" &&
                                  newSurveyLocal?.survey?.endTime
                                  ? error && error[field?.id]
                                  : field.id !== "endTime"
                                    ? error && error[field?.id]
                                    : ""
                                : false,
                              helperText: !disabledForm
                                ? field.id === "endTime" &&
                                  newSurveyLocal?.survey?.endTime
                                  ? error && error[field?.id]
                                  : field.id !== "endTime"
                                    ? error && error[field?.id]
                                    : ""
                                : "",
                            },
                          }}
                        />
                      );
                    })}
                  </Grid>
                </>
              )}
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageNewSurveyAppointment;
